// Copyright (c) 2021-2024 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import {
  CROSS_REGION_SET_ALLOWED_CROSS_ORIGIN,
  CROSS_REGION_SET_CLUSTER_ORIGIN_LIST,
  CROSS_REGION_SET_CROSS_REGION,
  CROSS_REGION_SET_IS_READY,
  CROSS_REGION_RESET_STATE,
} from './mutation-types';
import getDefaultState from './get-default-state';

const mutations = {
  [CROSS_REGION_RESET_STATE]: state => {
    const defaultState = getDefaultState();

    state.crossRegion = defaultState;
  },
  [CROSS_REGION_SET_ALLOWED_CROSS_ORIGIN]: (state, payload) =>
    (state.crossRegion.allowedCrossOrigin = payload),
  [CROSS_REGION_SET_CLUSTER_ORIGIN_LIST]: (state, payload) =>
    (state.crossRegion.clusterOriginList = payload),
  [CROSS_REGION_SET_CROSS_REGION]: (state, payload) =>
    (state.crossRegion.crossRegion = payload),
  [CROSS_REGION_SET_IS_READY]: (state, payload) =>
    (state.crossRegion.isReady = payload),
};

export default mutations;



// WEBPACK FOOTER //
// ./client/containers/cross-region/mutations.js